module.exports = __webpack_public_path__ + "static/media/mobile-blog-img2.d4ceb80b.png";